
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Info, Lightbulb, AlertTriangle, Flame, ShieldAlert } from 'lucide-react';

type CalloutType = 'NOTE' | 'TIP' | 'WARNING' | 'IMPORTANT' | 'CAUTION';

const CALLOUT_CONFIG: Record<CalloutType, { icon: React.ElementType; label: string; className: string }> = {
  NOTE: { icon: Info, label: 'Hinweis', className: 'callout-note' },
  TIP: { icon: Lightbulb, label: 'Tipp', className: 'callout-tip' },
  WARNING: { icon: AlertTriangle, label: 'Warnung', className: 'callout-warning' },
  IMPORTANT: { icon: Flame, label: 'Wichtig', className: 'callout-important' },
  CAUTION: { icon: ShieldAlert, label: 'Achtung', className: 'callout-caution' },
};

interface CalloutProps {
  type: CalloutType;
  children: string;
}

export default function Callout({ type, children }: CalloutProps) {
  const config = CALLOUT_CONFIG[type] ?? CALLOUT_CONFIG.NOTE;
  const Icon = config.icon;
  return (
    <div className={`callout ${config.className} not-prose my-5`}>
      <div className="callout-title">
        <Icon className="callout-icon" />
        <span>{config.label}</span>
      </div>
      <div className="callout-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
      </div>
    </div>
  );
}

export function isCalloutMarker(text: string): CalloutType | null {
  const m = text.trim().match(/^\[!(NOTE|TIP|WARNING|IMPORTANT|CAUTION)\]/i);
  return m ? m[1].toUpperCase() as CalloutType : null;
}

export function stripCalloutMarker(text: string): string {
  return text.replace(/^\s*\[!(NOTE|TIP|WARNING|IMPORTANT|CAUTION)\]\s*/i, '');
}
